export default __webpack_public_path__ + "static/media/12.81faaf74.png";